import React from 'react';
import { Layout, Menu } from 'antd';
import type { MenuProps } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ConfigurationsRoutes from '../../routes/parentSettings/ConfigurationsRoutes';
import { fetchAccountCustomFields } from '../../actions/parent/custom_fields/fetch';

const { Content, Sider } = Layout;
type MenuItem = Required<MenuProps>['items'][number];

const ConfigurationsSettingsPage: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(fetchAccountCustomFields());
  }, [dispatch]);

  const configurationsItems: MenuItem[] = [
    {
      key: '/settings/configurations',
      label: <Link to={{ pathname: `.` }}>{t('configurations:filtersTab')}</Link>,
    },
    {
      key: '/settings/configurations/export-builder-plus-templates',
      label: (
        <Link to={{ pathname: `export-builder-plus-templates` }}>
          {t('configurations:ebpsTab')}
        </Link>
      ),
    },
    {
      key: '/settings/configurations/lists',
      label: <Link to={{ pathname: `lists` }}>{t('configurations:dynamicFieldListsTab')}</Link>,
    },
  ];

  return (
    <Layout className="layout">
      <Sider theme="light">
        <Menu
          mode="inline"
          defaultSelectedKeys={['/settings/configurations']}
          selectedKeys={[location.pathname]}
          items={configurationsItems}
        />
      </Sider>
      <Content className="main-page-content">
        <ConfigurationsRoutes />
      </Content>
    </Layout>
  );
};

export default ConfigurationsSettingsPage;
